export default "__VITE_ASSET__CCkYQI5R__"